import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { Div, Span } from 'client/widget-components/basicComponents';
import { ResponsiveStylesProp } from 'client/widget-components/responsive-styles/responsiveStylesService';
import React from 'react';

export interface ColorSwatchStyles {
    swatch?: ResponsiveStylesProp;
    swatchSelected?: ResponsiveStylesProp;
}

export interface ColorSwatchProps {
    color: string;
    value: string | number;
    selected?: boolean;
    disabled?: boolean;
    onChange?: (value: string | number) => void;
    size?: number;
    styles?: ColorSwatchStyles;
    showLabel?: boolean;
}

const ColorSwatch = ({
    color,
    value,
    selected = false,
    disabled = false,
    onChange,
    size = 32,
    styles,
    showLabel = false,
}: ColorSwatchProps) => {
    const handleClick = () => {
        if (!disabled && onChange) {
            onChange(value);
        }
    };

    return (
        <Div styles={containerDefaultStyles} onClick={handleClick}
        >
            <Div
                styles={[
                    swatchWrapperDefaultStyles,
                    styles?.swatch,
                    selected && selectedStyles,
                    selected && styles?.swatchSelected,
                    disabled && disabledStyles,
                    {
                        [RuntimeMediaQuery.COMMON]: {
                            width: `${size}px`,
                            height: `${size}px`,
                        },
                    }
                ]}
                data-grab={selected ? 'color-swatch-wrapper-selected' : 'color-swatch-wrapper'}
                data-auto='color-swatch'
                aria-checked={selected}
                aria-disabled={disabled}
            >
                <Div
                    styles={[defaultSwatchStyles, {
                        [RuntimeMediaQuery.COMMON]: {
                            backgroundColor: color,
                        },
                    }]}
                    data-grab='color-swatch-inner'
                />
            </Div>
            {showLabel && <Span styles={labelDefaultStyles}>{value}</Span>}
        </Div>
    );
};

const containerDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        gap: '8px',
        cursor: 'pointer',
    },
};


const swatchWrapperDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        outline: 'none',
        padding: '2px',
        cursor: 'pointer',
        border: '1px solid transparent',
    },
};

const disabledStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        cursor: 'not-allowed',
        opacity: 0.5,
    },
};
const selectedStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        border: '1px solid #30373a',
    },
};

const defaultSwatchStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        flexShrink: 0,
        borderRadius: 'inherit',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        borderBottomRightRadius: 'inherit',
        borderBottomLeftRadius: 'inherit',
        border: '1px solid #E4E4E6',
    }
}

const labelDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        fontWeight: 400,
        fontStyle: 'Regular',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0px',
    },
};

export default ColorSwatch;
